import PropTypes from "prop-types";

import { flashClassName, getFlashMessage } from "../utils";

const FlashBanner = ({ flash }) => {
  const className = flashClassName(flash);
  const message = getFlashMessage(flash);

  if (!className || !message) {
    return null;
  }

  return <div className={className}>{message}</div>;
};

FlashBanner.propTypes = {
  flash: PropTypes.object,
};

export default FlashBanner;
